import axios from "axios";

export const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

export const thumbUrl = (url) => (url ? (url.includes("?") ? `${url}&size=thumb` : `${url}?size=thumb`) : url);

export function formatApiError(detail) {
  if (detail == null) return "Er ging iets mis. Probeer opnieuw.";
  if (typeof detail === "string") {
    const junk = detail.length > 220 || /<html|cloudflare|could not parse|bad gateway|origin web server/i.test(detail);
    return junk ? "De server was even niet bereikbaar. Probeer het zo opnieuw." : detail;
  }
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

const TRANSIENT = new Set([502, 503, 504, 520, 521, 522, 523, 524]);
const wait = (ms) => new Promise((r) => setTimeout(r, ms));

api.interceptors.response.use(undefined, async (error) => {
  const cfg = error.config || {};
  const status = error.response?.status;
  const transient = !error.response || TRANSIENT.has(status);
  const method = (cfg.method || "get").toLowerCase();
  cfg._retryCount = cfg._retryCount || 0;
  if (transient && method === "get" && cfg._retryCount < 2) {
    cfg._retryCount += 1;
    await wait(600 * cfg._retryCount);
    return api.request(cfg);
  }
  return Promise.reject(error);
});
